import script from "./FormSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FormSidebar.vue?vue&type=style&index=0&id=690af068&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-690af068"]])

export default __exports__